<template>
  <div v-if="isPopupOpen" class="layer-popup-view">
    <component :is="layerPopup" :payloads="payloads" @on-close="onClickClose" />
  </div>
</template>
<script setup>
  import { useRouter } from 'vue-router/composables'
  import { useLayerPopupLoader } from '@/common/use/useLayerPopupLoader'

  const router = useRouter()
  const { layerPopup, isPopupOpen, payloads } = useLayerPopupLoader()

  const onClickClose = () => {
    router.back()
  }
</script>
<style lang="scss" scoped>
  .layer-popup-view {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 9999;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #1b1b1b;
    overflow-x: hidden;
    overflow-y: auto;
  }
</style>
